import { Action, createReducer, on } from "@ngrx/store";
import { Collection, CryptoState, CRYPTO_INIT_STATE } from "./crypto.state";
import * as cryptoActions from './crypto.actions';

const _cryptoReducer = createReducer(
    CRYPTO_INIT_STATE,
    //connect to wallet
    on(
        cryptoActions.connectWallet,
        (state, action) => {
            return {
                ...state,
            }
        }
    ),
    // load wallet without firebase setDoc
    on(
        cryptoActions.loadWallet,
        (state, action) => {
            return {
                ...state,
                address: action.address,
                chainId: action.chainId,
                provider: action.provider,
                chain: action.chain,
                session: action.session,
                connectedAt: action.connectedAt,
            }
        }
    ),
    //disconnect wallett
    on(
        cryptoActions.disconnectWallet,
        (state, action) => {
            return {
                ...CRYPTO_INIT_STATE
            }
        }
    ),
    //transactions loaded
    on(
        cryptoActions.nftAssetsLoaded,
        (state, action) => {
            return {
                ...state,
                nftAssets: action.nftAssets,
            }
        }
    ),
    //set loading status
    on(
        cryptoActions.setLoadingStatus,
        (state, action) => {
            return {
                ...state,
                loadingStatus: action.status
            }
        }
    ),
    //save favorite nft s
    on(
        cryptoActions.saveFavorites,
        (state, action) => {
            return {
                ...state,
                favorites: [...action.favorites]
            }
        }
    ),
    //remove favorite nfts
    on(
        cryptoActions.removeFavorites,
        (state, _) => {
            return {
                ...state,
                favorites: []
            }
        }
    ),
    //save collections
    on(
        cryptoActions.addCollections,
        (state, action) => {
            const collections: Collection[] = action.collections.map(collection => {
                return {
                    name: collection.name,
                    imageUrl: collection.image,
                    bannerImageUrl: collection.banner,
                    description: collection.description,
                    address: collection.collectionAddress
                }
            })
            return {
                ...state,
                collections
            }
        }
    ),
    //Clear state
    on(
        cryptoActions.clearCryptoState,
        (state, action) => {
            return {
                ...CRYPTO_INIT_STATE
            }
        }
    ),
);

export function cryptoReducer(state: CryptoState, action: Action) {
    return _cryptoReducer(state, action);
}
